import {
  differenceInSeconds,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
  differenceInMonths,
  differenceInYears,
} from 'date-fns'

const shortenText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text
  } else {
    return text.substring(0, maxLength) + '...'
  }
}

/** e.g. `1s`, `12m`, `3h`, `5d`, `2mo`, `1y` — not "5 minutes ago". */
function formatCompactTimeAgo(fromDate, now = new Date()) {
  if (!(fromDate instanceof Date) || Number.isNaN(fromDate.getTime())) return ''
  if (fromDate > now) return '0s'
  const sec = differenceInSeconds(now, fromDate)
  if (sec < 60) return `${sec}s`
  const min = differenceInMinutes(now, fromDate)
  if (min < 60) return `${min}m`
  const hrs = differenceInHours(now, fromDate)
  if (hrs < 24) return `${hrs}h`
  const days = differenceInDays(now, fromDate)
  if (days < 30) return `${days}d`
  const months = differenceInMonths(now, fromDate)
  if (months < 12) return `${months}mo`
  return `${differenceInYears(now, fromDate)}y`
}

export { shortenText, formatCompactTimeAgo }
